import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const AlertsIcon = ({ color = Colors.interaction }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_905_1209"
      style={{ maskType: 'alpha' }}
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H24V24H0z" />
    </mask>
    <g mask="url(#mask0_905_1209)">
      <path
        fill={color}
        d="M2.615 9.913c0-1.474.314-2.835.94-4.082A9.467 9.467 0 016.09 2.67l.925 1.167a7.886 7.886 0 00-2.118 2.65c-.521 1.047-.782 2.188-.782 3.425h-1.5zm17.27 0c0-1.237-.261-2.38-.782-3.43a7.873 7.873 0 00-2.118-2.654l.925-1.158a9.466 9.466 0 012.535 3.16c.626 1.247.94 2.608.94 4.082h-1.5zM4.5 18.885v-1.5h1.808V9.923c0-1.345.415-2.534 1.245-3.567a5.518 5.518 0 013.197-1.983V3.75c0-.346.122-.641.365-.885.244-.243.539-.365.885-.365s.641.122.885.365c.243.244.365.539.365.885v.623a5.518 5.518 0 013.197 1.983c.83 1.033 1.245 2.222 1.245 3.567v7.462H19.5v1.5h-15zm7.5 2.807c-.499 0-.925-.176-1.278-.53a1.742 1.742 0 01-.53-1.277h3.616c0 .498-.177.924-.53 1.277-.353.354-.78.53-1.278.53zm-4.192-4.307h8.384V9.923c0-1.158-.409-2.146-1.228-2.964C14.146 6.14 13.158 5.73 12 5.73s-2.146.409-2.964 1.228c-.819.818-1.228 1.806-1.228 2.964v7.462z"
      />
    </g>
  </svg>
);

AlertsIcon.propTypes = {
  color: PropTypes.string
};

export default AlertsIcon;
